<template>
  <nt-auth-template>
    <v-row dense align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card color="loginBackground">
          <v-card-text class="text-center">
            <img class="my-3" :src="info.app_logo"/>
            <h3 class="text-h5 mt-4 mb-0">Registro</h3>
          </v-card-text>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-form @submit.prevent="submit()" v-model="form.valid" lazy-validation method="post" id="register" ref="form">
                  <p>Dados pessoais</p>
                  <v-text-field
                    name="name"
                    label="Nome"
                    v-model="user.name"
                    required
                    prepend-icon="mdi-account"
                    type="text"
                    :error-messages="error.messages.name"
                    autofocus
                    color="loginFont"/>
                  <v-text-field
                    name="birth_date"
                    label="Data de nascimento"
                    v-model="user.birth_date"
                    required
                    prepend-icon="mdi-cake"
                    v-mask="'##/##/####'"
                    type="text"
                    :error-messages="error.messages.birth_date"
                    color="loginFont"/>
                  <v-text-field
                    name="cpf"
                    label="CPF"
                    v-model="user.cpf"
                    required
                    prepend-icon="mdi-account-box"
                    v-mask="'###.###.###-##'"
                    type="text"
                    :error-messages="error.messages.cpf"
                    color="loginFont"/>
                  <v-select
                    :items="genders"
                    name="gender"
                    label="Gênero"
                    v-model="user.gender"
                    required
                    prepend-icon="mdi-face"
                    type="text"
                    :error-messages="error.messages.gender"
                    color="loginFont"/>
                  <v-select
                    :items="gender_identities"
                    name="gender_identity"
                    label="Identidade de gênero"
                    v-model="user.gender_identity"
                    required
                    prepend-icon="mdi-face-recognition"
                    type="text"
                    :error-messages="error.messages.gender_identity"
                    color="loginFont"/>
                  <v-text-field
                    name="naturalness"
                    label="Naturalidade"
                    v-model="user.naturalness"
                    required
                    prepend-icon="mdi-flag"
                    type="text"
                    :error-messages="error.messages.naturalness"
                    color="loginFont"/>
                  <p>Dados de contato</p>
                  <v-text-field
                    name="number"
                    label="Telefone"
                    v-model="user.phone_number"
                    required
                    prepend-icon="mdi-phone"
                    v-mask="'## # #### ####'"
                    type="text"
                    :error-messages="error.messages.phone_number"
                    color="loginFont"/>
                  <p>Dados de endereço</p>
                  <v-select
                    :items="states"
                    name="state"
                    label="Estado"
                    v-model="user.address_state"
                    required
                    prepend-icon="mdi-city"
                    type="text"
                    :error-messages="error.messages.address_state"
                    color="loginFont"/>
                  <v-select
                    :items="cities"
                    name="city"
                    label="Cidade"
                    v-model="user.address_city"
                    required
                    prepend-icon="mdi-home-group"
                    type="text"
                    :error-messages="error.messages.address_city"
                    color="loginFont"/>
                  <v-text-field
                    name="street"
                    label="Rua/Avenida"
                    v-model="user.address_street"
                    required
                    prepend-icon="mdi-road"
                    type="text"
                    :error-messages="error.messages.address_street"
                    color="loginFont"/>
                  <v-text-field
                    name="neighborhood"
                    label="Bairro"
                    v-model="user.address_neighborhood"
                    required
                    prepend-icon="mdi-home-city"
                    type="text"
                    :error-messages="error.messages.address_neighborhood"
                    color="loginFont"/>
                  <v-text-field
                    name="cep"
                    label="CEP"
                    v-model="user.address_cep"
                    required
                    prepend-icon="mdi-email"
                    v-mask="'#####-###'"
                    type="text"
                    :error-messages="error.messages.address_cep"
                    color="loginFont"/>
                  <v-text-field
                    name="number"
                    label="Número"
                    v-model="user.address_number"
                    prepend-icon="mdi-numeric"
                    type="numeric"
                    :error-messages="error.messages.address_number"
                    color="loginFont"/>
                  <v-text-field
                    name="complement"
                    label="Complemento"
                    v-model="user.address_complement"
                    prepend-icon="mdi-pencil"
                    type="numeric"
                    :error-messages="error.messages.address_complement"
                    color="loginFont"/>
                  <p>Dados de acesso</p>
                  <v-text-field
                    name="email"
                    label="Email"
                    v-model="user.email"
                    required
                    prepend-icon="mdi-email"
                    type="email"
                    :error-messages="error.messages.email"
                    color="loginFont"/>
                  <v-text-field
                    name="password"
                    label="Senha"
                    v-model="user.password"
                    required
                    prepend-icon="mdi-key"
                    :append-icon="passVisibility ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="passVisibility = !passVisibility"
                    :type="passVisibility ? 'text' : 'password'"
                    :error-messages="error.messages.password"
                    color="loginFont"/>
                  <v-text-field
                    name="password-confirmation"
                    label="Confirmar Senha"
                    v-model="user.password_confirmation"
                    required
                    prepend-icon="mdi-key"
                    :append-icon="passVisibility ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="passVisibility = !passVisibility"
                    :type="passVisibility ? 'text' : 'password'"
                    color="loginFont"/>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn text exact :to="{ name: 'auth.login' }">Login</v-btn>
            <v-spacer/>
            <v-btn exact type="submit" form="register" color="loginButton">Cadastrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </nt-auth-template>
</template>

<script>
import NtAuthTemplate from '@/components/Utils/NtAuthTemplate'
import store from '@/store'
import { mapGetters } from 'vuex'
import { State } from '@/services/resources'

export default {
  components: {
    NtAuthTemplate
  },
  mounted () {
    State.get().then((response) => {
      this.states = response.body.map((item) => {
        return { text: item.name, value: item.id }
      })
    })
  },
  watch: {
    'user.address_state' (val) {
      State.cities(val).then((response) => {
        this.cities = response.body.map((item) => {
          return { text: item.name, value: item.id }
        })
      })
    }
  },
  data () {
    return {
      genders: [
        { text: 'Masculino', value: 'M' },
        { text: 'Feminino', value: 'F' }
      ],
      gender_identities: [
        { text: 'Masculino', value: 'M' },
        { text: 'Feminino', value: 'F' },
        { text: 'Não Binário', value: 'NB' },
        { text: 'Não Informado', value: 'NI' }
      ],
      states: [],
      cities: [],
      user: {
        name: '',
        birth_date: '',
        cpf: '',
        gender: '',
        gender_identity: '',
        naturalness: '',
        phone_number: '',
        address_state: '',
        address_city: '',
        address_street: '',
        address_neighborhood: '',
        address_cep: '',
        address_number: '',
        address_complement: '',
        email: '',
        password: '',
        password_confirmation: ''
      },
      error: {
        error: false,
        messages: {}
      },
      form: {
        valid: false
      },
      passVisibility: false
    }
  },
  methods: {
    submit () {
      this.user.cpf = this.user.cpf.replace(/\D+/g, '')
      this.user.phone_number = this.user.phone_number.replace(/\D+/g, '')
      this.user.address_cep = this.user.address_cep.replace(/\D+/g, '')

      this.error.error = false
      this.error.messages = []
      if (this.$refs.form.validate()) {
        store.dispatch('App/register', this.user)
          .then(() => {
            this.clear()
            this.$router.push({ name: 'auth.login' })
          })
          .catch((responseError) => {
            this.error.error = true
            this.user.password = ''
            this.user.password_confirmation = ''
            if (responseError.status === 422) {
              console.log(responseError.data.errors)
              this.error.messages = responseError.data.errors
              this.form.valid = false
            } else {
              this.$toasted.error(responseError.data.message)
            }
          })
      }
    },
    clear () {
      this.$refs.form.reset()
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'App/isAuthenticated',
      info: ['App/info']
    })
  }
}
</script>
